import './style.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NormalButton from '../buttons/normalButton';

const InputTitle = props => (
  <div className={classNames('title-wrapper', props.className)}>
    <p>
      {props.title}
      {props.isRequired && (
        <span className={props.isRequired ? 'required' : ''}> *</span>
      )}
    </p>
    {props.isChangePassword && (
      <NormalButton
        className="change-pw"
        type="text"
        onClick={props.onForgetPasswordClick}
      />
    )}
  </div>
);
InputTitle.defaultProps = {
  className: '',
  title: '',
  isRequired: false,
  isChangePassword: false,

  onForgetPasswordClick: () => {},
};

InputTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  isRequired: PropTypes.bool,
  isChangePassword: PropTypes.bool,

  onForgetPasswordClick: PropTypes.func,
};

export default InputTitle;
